import { Link } from "react-router-dom";
import { mockVideos } from "@/mocks/videos";

export default function TrendingSidebar() {
  const trending = [...mockVideos].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="py-8 md:py-10 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-2 mb-5">
          <div className="w-1 h-5 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">🔥 热门排行</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {trending.map((video, idx) => (
            <Link
              key={video.id}
              to={`/article/${video.slug}`}
              className="group flex items-start gap-3 p-3 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all"
            >
              <span className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-sm font-bold ${
                idx < 3 ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-600"
              }`}>
                {idx + 1}
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{video.views.toLocaleString()} 次观看</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}